export const setPaymentData = (payment) => ({ type: 'PAYMENTS_SET_PAYMENT', payment });
export const clearPaymentData = () => ({ type: 'PAYMENTS_CLEAR_PAYMENT' });

export const setPaymentMessage = (message, details) => ({
  type: 'PAYMENTS_SET_MESSAGE',
  message,
  details
});

export const clearPaymentActionMessages = () => ({ type: 'PAYMENTS_CLEAR_ACTION_MESSAGES' });
export const clearPaymentActionMessage = (id) => ({ type: 'PAYMENTS_CLEAR_ACTION_MESSAGE', id });

export const setPaymentActionMessages = (paymentActionMessages) => ({
  type: 'PAYMENTS_SET_ACTION_MESSAGES',
  paymentActionMessages: paymentActionMessages.map((paymentActionMessage) => ({
    id: Math.floor(Math.random()),
    ...paymentActionMessage
  }))
});

export const setSmbHighlightedRows = (highlightedRows) => ({
  type: 'PAYMENTS_SET_SMB_HIGHLIGHT_ROWS',
  highlightedRows
});

export const setImportGridMessages = (importGridMessages) => ({
  type: 'PAYMENTS_SET_IMPORT_GRID_MESSAGES',
  importGridMessages
});
